import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useFetchPatners } from '../../hooks/useFetchPartners';
import { getPartnerConsentsToRender } from './Consents.utils';
import Button from '../../../../components/Button';
import Checkbox from '../../../../components/Checkbox';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { ModalSteps } from '../../constants';
import sharedStyles from '../../styles.module.scss';
const Consents = ({ selectedPartner = null, isLoading = false, onSubmit, onFetchPartners, onSwitchStep }) => {
    const { t } = useTranslation();
    const [isTermsCheckboxChecked, setTermsCheckboxChecked] = useState(false);
    const [isMarketingCheckboxChecked, setMarketingCheckboxChecked] = useState(false);
    const [partnerConsents, setPartnerConsents] = useState([]);
    const [acceptedPartnerConsents, setAcceptedPartnerConsents] = useState([]);
    const [errors, setErrors] = useState({});
    const { data: partnersData } = useFetchPatners(onFetchPartners);
    const handleClickAcceptPartnerConsents = (consentType) => {
        if (acceptedPartnerConsents.includes(consentType)) {
            setAcceptedPartnerConsents((prevState) => prevState.filter((consent) => consent !== consentType));
            return;
        }
        setAcceptedPartnerConsents((prevState) => ([...prevState, consentType]));
    };
    const handleSubmit = (event) => {
        event.preventDefault();
        let formErrors = {};
        if (!isTermsCheckboxChecked) {
            formErrors = { terms: t('authentication.consents.conditionsError') };
        }
        if (partnerConsents.length > 0) {
            partnerConsents.forEach((consent) => {
                if (consent.required && !acceptedPartnerConsents.includes(consent.consentType)) {
                    formErrors = Object.assign(Object.assign({}, formErrors), { [consent.consentType]: consent.error });
                }
            });
        }
        setErrors(formErrors);
        if (Object.keys(formErrors).length > 0)
            return;
        let consentsData = {};
        const consents = ['terms'];
        if (isMarketingCheckboxChecked) {
            consents.push('marketing');
        }
        consentsData = { consents };
        if (acceptedPartnerConsents.length > 0) {
            consentsData = Object.assign(Object.assign({}, consentsData), { partners_consents: partnerConsents.map((consent) => consent.consentType) });
        }
        onSubmit(consentsData);
    };
    const onSwitchBack = () => {
        if (selectedPartner == null && onFetchPartners != null) {
            onSwitchStep(ModalSteps.PARTNER_SELECT);
            return;
        }
        onSwitchStep(ModalSteps.USER_INFO);
    };
    useEffect(() => {
        if (partnersData != null && selectedPartner != null) {
            setPartnerConsents(getPartnerConsentsToRender(selectedPartner, partnersData));
        }
    }, [partnersData, selectedPartner]);
    return (_jsxs("form", Object.assign({ onSubmit: handleSubmit, className: sharedStyles.form, "data-cy": "consents-step" }, { children: [_jsx("div", Object.assign({ className: sharedStyles.formItem }, { children: _jsx(Checkbox, { name: "marketing", handleOnChange: () => setMarketingCheckboxChecked(!isMarketingCheckboxChecked), label: t('authentication.consents.marketingCheckboxLabel'), disabled: isLoading, "data-cy": "consents-step-marketing-checkbox" }) })), _jsx("div", Object.assign({ className: sharedStyles.formItem }, { children: _jsx(Checkbox, { name: "terms", handleOnChange: (isChecked) => setTermsCheckboxChecked(isChecked), label: _jsx("span", { dangerouslySetInnerHTML: { __html: t('authentication.consents.conditionsCheckboxLabel') } }), isError: (errors === null || errors === void 0 ? void 0 : errors.terms) != null, errorMessage: errors.terms, disabled: isLoading, "data-cy": "consents-step-conditions-checkbox" }) })), partnerConsents.map((consent) => (_jsx("div", Object.assign({ className: sharedStyles.formItem }, { children: _jsx(Checkbox, { handleOnChange: () => handleClickAcceptPartnerConsents(consent.consentType), label: consent.text, name: consent.text, isError: (errors === null || errors === void 0 ? void 0 : errors[consent.id]) != null, errorMessage: errors[consent.consentType], disabled: isLoading, "data-cy": `consents-step-${consent.consentType}-checkbox` }) }), consent.id))), _jsx("div", { className: sharedStyles.break }), _jsxs("div", Object.assign({ className: sharedStyles.formNavigationButtons }, { children: [_jsx(Button, Object.assign({ onClick: onSwitchBack, kind: "text", size: "fluid", icon: _jsx(FontAwesomeIcon, { icon: faArrowLeft, className: sharedStyles.buttonIcon }), disabled: isLoading, "data-cy": "consents-step-go-back-button" }, { children: t('authentication.partnerSelect.backCta') })), _jsx(Button, Object.assign({ type: "submit", color: "pink", size: "fluid", isLoading: isLoading, "data-cy": "consents-step-submit-button" }, { children: t('authentication.consents.submit') }))] }))] })));
};
export default Consents;
